<template>
    <div class="px-4 py-2">
        <b-table v-if="!error"
                 :busy="fetching"
                 :items="rows"
                 :fields="columns"
                 class="shx-table w-100"
                 hover dark fixed small
                 sort-icon-left
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc">

            <template #cell(movix_id)="data">
                <span v-if="data.item.movix_id" class="badge badge-info">{{ data.item.movix_id }}</span>
                <span v-else class="badge badge-secondary">—</span>
            </template>

            <template #cell(admissions)="data">
                <span>{{ formatInt(data.item.admissions) }}</span>
            </template>

            <template #cell(real)="data">
                <span>{{ data.item.real !== undefined && data.item.real !== null ? data.item.real + '%' : '—' }}</span>
            </template>

            <template #table-busy>
                <table-spinner/>
            </template>
        </b-table>

        <div v-if="error" class="text-center text-muted py-3">{{ error }}</div>
        <div v-else-if="!fetching && !rows.length" class="text-center text-muted py-3">No titles.</div>
    </div>
</template>

<script>
import {BTable} from "bootstrap-vue";
import axios from "axios";
import TableSpinner from "./TableSpinner";

export default {
    name: "AdmissionsTitlesTable",
    components: {
        TableSpinner,
        BTable,
    },
    props: {
        bucket: {type: String, required: true, validator: v => ['day', 'week'].includes(v)},
        parentKey: {type: String, required: true},
        theatreCode: {type: String, required: true},
        saleshouse: {type: String, default: null},
    },
    data() {
        const cols = [
            {key: 'movix_id', label: 'Movix', thClass: 'shx-th-80', tdClass: 'text-center'},
            {key: 'title', label: 'Title', sortable: true},
            {key: 'admissions', label: 'Admissions', sortable: true, thClass: 'text-right shx-th-140', tdClass: 'text-right'},
        ];

        if (this.bucket === 'week') {
            cols.push({key: 'real', label: 'Real %', sortable: true, thClass: 'text-right shx-th-100', tdClass: 'text-right'});
        }

        return {
            fetching: false,
            rows: [],
            error: null,
            columns: cols,
            sortBy: 'admissions',
            sortDesc: true,
        };
    },
    mounted() {
        this.fetch();
    },
    watch: {
        saleshouse() {
            if (this.bucket === 'week') {
                this.fetch();
            }
        },
    },
    methods: {
        fetch() {
            this.fetching = true;
            this.error = null;

            const url = `/admissions/${this.bucket}/${this.parentKey}/cinemas/${this.theatreCode}/titles`;
            const params = this.bucket === 'week' ? {saleshouse: this.saleshouse} : {};

            axios
                .get(url, {params})
                .then(response => {
                    this.rows = response.data.data.rows || [];
                })
                .catch(err => {
                    this.error = err.message || 'Failed to load titles.';
                })
                .finally(() => {
                    this.fetching = false;
                });
        },
        formatInt(v) {
            return (v || 0).toLocaleString();
        },
    }
}
</script>
